<template>
  <div>
    <div class="d-flex justify-center flex-column pt-0 mb-0">
      <v-img
        alt="Woman on computer"
        class="grey darken-4"
        max-height="300"
        :src="banner_src"
      >
        <div class="business-header-div redx d-flex align-end pl-4 pr-4 pb-2">
          <div>
            <v-avatar tile color="grey" size="164" class="logo-avatar">
              <v-img
                contain
                :src="logo_src"
                alt="Company Logo"
              />
            </v-avatar>
          </div>
          <div
            class="flex-grow-1 d-flex flex-column justify-space-between business-name-div"
          >
            <div class="business-name">
              {{business.name}}
            </div>
            <div class="business-sub-name">{{business.tag_line}}</div>
            <div class="business-small-facts d-flex justify-space-between">
              <span class="success--text local-badge"
                ><small>
                    {{ parseInt(business.is_local_company) == 1 ? "LOCAL COMPANY" : "NOT LOCAL"}}
                </small></span
              >
              <span><small>Joinned On:</small> {{business.joined_on}}</span>
              <span><small>Registered by:</small> {{business.user.first_name}} {{business.user.last_name}}</span>
            </div>
          </div>
          <div class="">
            <v-avatar color="grey" size="80">
              <v-img :src="verification_src[parseInt(business.is_verified)]" alt="Verification Stamp" />
            </v-avatar>
          </div>
        </div>
      </v-img>
      <div class="d-flex justify-space-between ">
        <div>
          Stars rating
        </div>
        <div>
          Reviews Count
        </div>
        <div>
          Searches Count
        </div>
        <div>
          Views Count
        </div>
        <div class="flex-grow-1">
          Branch: Of "x-y-z"
          No Branches
          Is Main Branch
        </div>
      </div>
    </div>

    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        :to="'/admin/categories/view/' + $route.params.id + '/edit'"
        small
        rounded
        class="mr-4"
        outlined
        color="warning"
      >
        <v-icon left>mdi-pen</v-icon>Rate Us
      </v-btn>
      <v-btn
        :to="'/admin/categories/view/' + $route.params.id + '/delete'"
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-times</v-icon>Review
      </v-btn>

      <v-btn
        :to="'/admin/categories/view/' + $route.params.id + '/delete'"
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-times</v-icon>Send Message
      </v-btn>

      <v-btn
        :to="'/admin/categories/view/' + $route.params.id + '/delete'"
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-times</v-icon>Verify
      </v-btn>

      <v-btn
        :to="'/admin/categories/view/' + $route.params.id + '/delete'"
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-times</v-icon>Edit Header
      </v-btn>

      <v-btn
        :to="'/admin/categories/view/' + $route.params.id + '/delete'"
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-times</v-icon>Delete
      </v-btn>
    </div>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Description"
      id="owner_view_business_description_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Please Rate This Business"
      id="owner_view_business_rate_form_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Location"
      id="owner_view_business_location_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Please Review This Business"
      id="owner_view_business_review_form_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Contact Information"
      id="owner_view_business_contact_info_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Contact This Business Via a Message"
      id="owner_view_business_contact_us_form_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Holidays Working Schedule "
      id="owner_view_business_holidays_schedule_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Normal Weekly Working Schedule "
      id="owner_view_business_normal_schedule_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Photo Gallery "
      id="owner_view_business_photo_gallery_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Meta Data "
      id="owner_view_business_meta_section"
    ></CardedSectionHeader>
    <div>
      Meta data includes also the hash tags ,
      verification, join date, etc facts
    </div>


    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Searches List "
      id="owner_view_business_searches_list_section"
    ></CardedSectionHeader>


    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Views List "
      id="owner_view_business_views_list_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Ratings List "
      id="owner_view_business_ratings_list_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Reviews List "
      id="owner_view_business_reviews_list_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Messages List "
      id="owner_view_business_messages_list_section"
    ></CardedSectionHeader>


    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Activity Graph "
      id="owner_view_business_activity_graph_section"
    ></CardedSectionHeader>

    
    <br />
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "OwnerBusinessesView",
  data: function () {
    return {
      business_id: 0,
      banner_src: Utils.default_business_banner,
      logo_src: Utils.default_business_logo,
      verification_src: {
        0: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1607508894/botswana%20services/website%20assets/verification_missing_rrfc7y.png",
        1: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1607508093/botswana%20services/website%20assets/verification_pending_cp3bln.png",
        2: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1607507535/botswana%20services/website%20assets/verified_stamp_xqikbc.jpg",
      },
      _user: null,
      business: Utils.get_default_business(),
    };
  },
  methods: {
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user.id,
        },
        (res) => {
          if (res) {
            this.business = res;
          }
          this.banner_src = this.business.banner;
          this.logo_src = this.business.logo;
        },
        (errors) => {
          console.log("Errors while loading owners my business ", errors);
        }
      );
    },
  },
  mounted() {
    //   console.log(this.$route.params);
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    this.load_business(this.business_id);
  },
};
</script>

<style scoped>
.logo-avatar {
  border-radius: 15px !important;
  border-bottom-right-radius: 0px !important;
}
.business-header-div {
  height: 300px;
}

.business-name-div {
  background-color: #fff6f694;
  max-height: 200px;
  height: 50%;
  padding: 10px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.business-name {
  text-align: left;
  font-size: 24px;
  font-weight: bold;
  text-transform: capitalize;
  text-shadow: 2px 1px 2px white;
  border-bottom: 1px dotted #ded3d3;
}
.business-sub-name {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
  text-transform: capitalize;
  text-shadow: 1px 0px 1px #ffffff8f;
  border-bottom: 1px dotted #ded3d3;
}
.business-small-facts {
  font-weight: bold;
}
.local-badge {
  text-shadow: 0px 1px 0px #ffffff;
  background-color: #ffffffc9;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 5px;
}
</style>